module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "topcoat-switch",
    class: {
      'is-danger': _vm.errors.has(_vm.checkboxName)
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.expression),
      expression: "expression"
    }],
    staticClass: "topcoat-switch__input",
    attrs: {
      "type": "checkbox",
      "name": _vm.checkboxName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topcoat-switch__toggle"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.checkboxName)),
      expression: "errors.has(checkboxName)"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("X")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9c17a9ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Switcher.vue
// module id = 117
// module chunks = 2